import { Breadcrumb, Col, Row } from "antd";
import Title from "../UI/Title/Title";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { ScanOutlined } from "@ant-design/icons";
import ReturnList from "./ReturnList";
import { ScanReturn } from "./scanreturn";
import { useState } from "react";
import { getBillsReturns } from "../../api/returnbill";
import { useMutation } from "react-query";

function Returns() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const [isopenScan, setIsOpenScan] = useState(false);

  const [search, setSearch] = useState<string>("");
  const [returnedData, setReturnedData] = useState<[]>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getReturnedData({
      limit: page * 10 + 10,
      q: "",
    }).then((res) => {
      setReturnedData(res.data.data);
      setSearch("");
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getReturnedData({
      limit: page * 10 + 10,
      q: search,
    }).then((res: any) => {
      setReturnedData(res.data.data);
    });
  };

  const getReturnedData = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ReturnedDataMutation(params);
  };

  const {
    mutateAsync: ReturnedDataMutation,
    isLoading: isReturnedDataLoading,
  } = useMutation("getBillsReturns", getBillsReturns);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              {
                title: (
                  <>
                    <span className="breadcrumbcolor">
                      {" "}
                      {t("returns-list")}{" "}
                    </span>
                  </>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("returns-list")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col
          offset={12}
          span={6}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxWidth: "100%",
              }}
              onClick={() => setIsOpenScan(true)}
            >
              <ScanOutlined style={{ fontSize: "22px" }} />
              <span>{t("scan")}</span>
            </div>
          </Col>
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => navigate(`/return/create`)} />
        </Col>
        <Col offset={1} span={22}>
          <ReturnList
            isReturnedDataLoading={isReturnedDataLoading}
            returnedData={returnedData}
            setReturnedData={setReturnedData}
            ReturnedDataMutation={ReturnedDataMutation}
            page={page}
            setPage={setPage}
            search={search}
            tableKey={tableKey}
          />
        </Col>
      </Row>
      <ScanReturn isopenScan={isopenScan} setIsOpenScan={setIsOpenScan} />
    </>
  );
}

export default Returns;
